import React, { Component } from 'react';
import { GeoJSON, FeatureGroup, Popup } from 'react-leaflet';
import PopupComponent from '../PopupComponent/PopupComponent';

class FeaturedMapRegion extends Component {
    constructor(props) {
        super(props);
        this[`${props.data}_ref`] = React.createRef()
    }
    // onEachFeature(feature: Object, layer: Object) {
    //     const popupContent = ` <Popup><p>Customizable Popups <br />with feature information.</p><pre>Borough: <br />${feature.properties.name}</pre></Popup>`
    //     layer.bindPopup(popupContent)
    // }
    generateArr = (data) => {
        // console.log(this[`${data}_ref`].current.leafletElement.getBounds())
        let _data = (this[`${data}_ref`].current.leafletElement.getBounds());
        let boundsArr = [
            [_data._northEast.lat, _data._northEast.lng],
            [_data._southWest.lat, _data._southWest.lng]
        ]
        // console.log(boundsArr)
        return JSON.stringify(boundsArr)
    }
    render() {
        const { data, name, styles, popupContent, popupType } = this.props;
        // console.log(name)
        if (this[`${data}_ref`].current !== null) {
            let a = document.getElementById(name);
            // console.log(this[`${data}_ref`].current.leafletElement.getBounds())
            // console.log(JSON.parse(JSON.stringify(this[`${data}_ref`].current.leafletElement.getBounds())))
            // console.log(typeof (this[`${data}_ref`].current.leafletElement.getBounds()._northEast))
        }

        return (
            <FeatureGroup fillOpacity={styles.fillOpacity} color={styles.color}>

                {/* <Popup>
                    <h2>{popupContent}</h2>
                    <Tooltip sticky>sticky Tooltip for Polygon</Tooltip>
                </Popup> */}
                {popupType === undefined ? <Popup>{popupContent}</Popup> : <PopupComponent {...this.props} />}
                <div id={name} value={this[`${data}_ref`].current !== null ? this.generateArr(data) : data}>
                    <GeoJSON
                        ref={this[`${data}_ref`]}
                        key={data}
                        data={require(`../../data/GeoJSONs/${data}.json`)}
                        style={styles}
                    />
                </div>
            </FeatureGroup>
        );
    }
}

export default FeaturedMapRegion;
